<template>
  <div class="space-y-8">
    <Channels :loading="pending" :channels="channels" @channel-deleted="removeChannelId" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Channels from '@/components/Channels/Index.vue';

export default {
  components: {
    Channels,
  },

  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
  }),

  computed: {
    ...mapState('ui/projectChannels', ['ids']),
    ...mapGetters('ui/projectChannels', ['channels']),
  },

  watch: {
    '$route.query': {
      handler(query) {
        if ('updated' in query) {
          this.loadChannels({ projectUuid: this.projectId });
        }
      },
    },
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/projectChannels', {
      loadChannels: 'load',
    }),

    ...mapMutations('ui/projectChannels', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        await this.loadChannels({ projectUuid: projectId });
      } catch (error) {
        //
      }

      this.pending = false;
    },

    removeChannelId(channelId) {
      this.setIds(this.ids.filter((id) => id !== channelId));
    },
  },
};
</script>
